<div class="container-fluid ter-container">
    <fap-attributes-layout
        [attributes]="globalRegistry.systemData.attributes"
        (deleteAttribute)="deleteAttribute($event)">
    </fap-attributes-layout>
</div>
